import i18n from '../i18n';

const stripPrefix = (key) => {
  if (!key) return '';
  const s = String(key);
  return s.startsWith('bill.') ? s.slice(5) : s;
};

const monthName = (m, translator) => {
  const n = Number(m);
  if (!Number.isInteger(n) || n < 1 || n > 12) return '';
  return translator(`billing:months.${n}`);
};

export const resolveBillName = (bill, t) => {
  if (!bill) return '';
  const translator = typeof t === 'function' ? t : i18n.t.bind(i18n);
  const fallback = bill.name || bill.title || '';
  const key = bill.name_key;
  if (!key) return fallback;
  const params = bill.name_params || {};
  const fullPath = `billing:bill_names.${stripPrefix(key)}`;
  const localized = translator(fullPath, { ...params, monthName: monthName(params.month, translator) });
  if (!localized || localized === fullPath) return fallback;
  return localized;
};
